// shortlink-redirect.component.ts
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ShortlinkService } from '../../../services/mdp/productos/shortLinks/short-links.service';
import {Toaster} from 'ngx-toast-notifications';

@Component({
  selector: 'app-shortlink-redirect',
  template: '<p>Redirigiendo...</p>',
})
export class ShortLinkRedirectComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private shortlinkService: ShortlinkService,
    private toaster: Toaster
  ) {}

  ngOnInit(): void {
    //const shortId = this.route.snapshot.paramMap.get('shortId');
    let shortId = this.route.snapshot.paramMap.get('shortId');

    if (!shortId) {
      this.toaster.open('Shortlink inválido', { type: 'danger' });
      return;
    }

    this.shortlinkService.resolverShortlink(shortId).subscribe({
      next: (res) => {
        if (res.long_url) {
          this.router.navigateByUrl(res.long_url, { skipLocationChange: true });
        }
      },
      error: () => this.toaster.open('Error al resolver el shortlink', { type: 'danger' })
    });
  }
}
